import React from "react";
import SchoolPartOne from "./school_pt_1_2026";
import SchoolPartTwo from "./school_pt_2_2026";
import { Collapse } from "antd";
import PdfDownload from "../../../../components/PdfDownload";
import type { CollapseProps } from "antd";
import Text from "../../../../context/language-context";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { eFORMSTATUS } from "../../../../utils/enum";
import EncryptUtils from "../../../../utils/encrypt";

const SchoolForm = () => {
  const [searchParams] = useSearchParams();
  const [currentStage, setCurrentStage] = useState<number | null>(null);
  const [activeKey, setActiveKey] = useState<string | string[]>("1");
  const [formItems, setFormItems] = useState<CollapseProps["items"]>([]);

  // Move Text calls outside of useEffect
  const partOneLabel = Text({
    tid: "SCHOOL_2026_PART_1_FORM_HEADING",
    def: "",
  });

  const partTwoLabel = Text({
    tid: "SCHOOL_2026_PART_2_FORM_HEADING",
    def: "",
  });

  useEffect(() => {
    if (searchParams.has("cs")) {
      const cs = EncryptUtils.decrypt(searchParams.get("cs") || "");
      if (cs) {
        const currSt = parseInt(cs);
        setCurrentStage(currSt);
        if (currSt >= eFORMSTATUS.STAGE1APPROVED) {
          setActiveKey("2");
        }
      }
    }
  }, [searchParams]);

  useEffect(() => {
    const schoolFormItem: CollapseProps["items"] = [
      {
        key: "1",
        label: partOneLabel, // Use precomputed label
        children: (
          <>
            <SchoolPartOne
              disabled={(currentStage as number) >= eFORMSTATUS.STAGE1APPROVED}
            />
          </>
        ),
      },
    ];

    if (currentStage !== null && currentStage >= eFORMSTATUS.STAGE1APPROVED) {
      schoolFormItem.push({
        key: "2",
        label: partTwoLabel, // Use precomputed label
        children: (
          <>
            <SchoolPartTwo
              disabled={(currentStage as number) >= eFORMSTATUS.STAGE2SUBMITTED}
            />
          </>
        ),
      });
    }

    setFormItems(schoolFormItem);
  }, [currentStage, partOneLabel, partTwoLabel]);

  if (currentStage === null) {
    return null; // or a loading spinner
  }

  return (
    <div>
      <Collapse
        accordion
        items={formItems}
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
      />
      {/* <PdfDownload /> */}
    </div>
  );
};

export default SchoolForm;
